<template>
    <div>
        <b-modal :width="500" :id="ModalId" :visible="true" scrollable centered no-close-on-backdrop no-close-on-esc :title="TitleWindow" ref="modalDosageTime" @close="this.emitEventCancel" @ok="this.handleOk" :ok-title="$t('Shared.Save')"  @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')"> 
            <form ref="form" @submit.stop.prevent="handleSubmit">
                <div v-for="(item,index) in marsTimesLocal" :key="index">
                    <b-row>
                        <b-col md="6" lg="6" sm="12">
                            <MdEdit 
                                v-bind:Label="$t('Shared.Time')"
                                v-bind:TypeProp="'time'"             
                                v-bind:Name="'adminTime'"
                                v-bind:isReadOnly="ReadOnly"      
                                v-model="item.adminTime"                        
                                v-on:change="ChangeTime">                                 
                            </MdEdit>
                        </b-col>   
                    </b-row>
                </div>
            </form>
        </b-modal>  
    </div>
</template>

<script>
import Utils from '@/common/utils'
import ShowMessage from '@/components/messages/ShowMessage.js'
import moment from "moment";

export default {
    name: 'ModalTime',
    mixins: [ShowMessage],  
    props: {
        ModalId: String,
        TitleWindow: String,
        marsTimes:Array,
        ReadOnly:Boolean
    },

    data(){
        return {
            marsTimesLocal:this.marsTimes.slice()
        }
    },

    methods: {
        emitEventOK(){     
            let arr = [];
            let dates = [];
            let _enddatetime = null;
            for(var i = 0; i < this.marsTimesLocal.length; i++){
                arr.push(
                {
                    adminTime:moment("1899-12-30T"+this.marsTimesLocal[i].adminTime).format('YYYY-MM-DDTHH:mm:ss')
                });

                dates.push(new Date(moment("1899-12-30T"+this.marsTimesLocal[i].adminTime).format('YYYY-MM-DDTHH:mm:ss')));
            }
        
            var max = new Date(Math.max(...dates));
            if(max){
                _enddatetime = Utils.formatTime(max, Utils.getDateTimeFormat());
            }

            let obj = {
                marsTimes: arr,
                EndDateTime :_enddatetime
            }
            this.$emit('RefreshDosageTime',obj);
        },

        handleOk(bvModalEvt) {      
            bvModalEvt.preventDefault();      
            this.handleSubmit()
        },

        handleSubmit() {      
            this.emitEventOK();
        },

        ChangeTime(){

        },

        emitEventCancel(){
            this.$emit('OnModalDosageTimeCancel');
        },    
    }
};
</script>